"use client";

import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { MapPin, House } from "lucide-react";
export default function ProjectListings() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const projects = [{
    id: 1,
    title: "East Legon Hills Unit 1",
    location: "East Legon, Accra",
    bedrooms: 4,
    price: "$450,000",
    status: "Available",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1531884/img/east_legon_hills_unit_one.png"
  }, {
    id: 2,
    title: "East Legon Hills Unit 2",
    location: "East Legon, Accra",
    bedrooms: 5,
    price: "$520,000",
    status: "Available",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1531884/img/east_legon_hills_unit_two.png"
  }, {
    id: 3,
    title: "East Legon Hills Unit 3",
    location: "East Legon, Accra",
    bedrooms: 4,
    price: "$475,000",
    status: "Reserved",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1531884/img/east_legon_hills_unit_three.png"
  }, {
    id: 4,
    title: "East Legon Hills Unit 4",
    location: "East Legon, Accra",
    bedrooms: 6,
    price: "$650,000",
    status: "Available",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1531884/img/east_legon_hills_unit_four.png"
  }, {
    id: 5,
    title: "East Legon Hills Unit 5",
    location: "East Legon, Accra",
    bedrooms: 4,
    price: "$485,000",
    status: "Available",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1531884/img/east_legon_hills_unit_five.png"
  }, {
    id: 6,
    title: "East Legon Hills Unit 6",
    location: "East Legon, Accra",
    bedrooms: 5,
    price: "$540,000",
    status: "Sold",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1531884/img/east_legon_hills_unit_six.png"
  }];
  return <section id="project-listings" className="bg-light-background py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-display text-4xl md:text-5xl text-foreground-light mb-4">
            The East Legon Hills Collection
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            10 luxury units featuring verified land titles, 24/7 live site monitoring, and GPS-stamped progress logs
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, i) => <Card key={project.id} data-index={i} className={`group overflow-hidden bg-secondary-light border border-border shadow-soft hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-2 ${isVisible ? i % 3 === 0 ? "animate-fade-in-up" : i % 3 === 1 ? "animate-fade-in-up-delay-100" : "animate-fade-in-up-delay-200" : "opacity-0"}`}>
              <div className="relative overflow-hidden h-64">
                <img src={project.image} alt={project.title} className="w-full h-full object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] group-hover:scale-102" />
                <div className="absolute top-4 right-4 px-3 py-1 rounded-md text-xs font-semibold bg-primary/90 text-foreground-primary backdrop-blur-sm">
                  {project.status}
                </div>
              </div>

              <CardHeader>
                <CardTitle className="text-2xl text-foreground-light">
                  {project.title}
                </CardTitle>
                <div className="flex items-center gap-2 text-sm text-muted-foreground">
                  <MapPin className="size-4" />
                  <span>{project.location}</span>
                </div>
              </CardHeader>

              <CardContent className="space-y-4">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2 text-foreground-light">
                    <House className="size-4" />
                    <span className="text-sm font-medium">{project.bedrooms} Bedrooms</span>
                  </div>
                  <div className="text-2xl font-display font-bold text-accent">
                    {project.price}
                  </div>
                </div>
              </CardContent>

              <CardFooter>
                <Link to="/DataRoomPage" className="w-full">
                  <Button variant="default" className="w-full bg-primary text-foreground-primary hover:bg-primary-hover transition-all duration-[var(--duration-fast)] relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-accent after:transition-all after:duration-[var(--duration-fast)] hover:after:w-full">
                    View Details
                  </Button>
                </Link>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}